import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Supplier, Suppliers } from '../Suppliers';
import type { IPackage } from './Packages.types';

@Identifiable
@Timestampable
@Untrackable
export class Package extends AbstractDocument<IPackage> {
  readonly collections = {};

  readonly translatable = (data: IPackage): NonNullable<IPackage['_translations']>[string] => ({
    description: data.description,
    name: data.name,
  });
}

export class Packages extends AbstractCollection<Package, IPackage> {
  static path = 'packages';

  constructor(document: Supplier) {
    super(document.collection(Packages.path), Package);
  }

  get supplier() {
    return Suppliers._.getById(this.reference.parent!.id);
  }
}
